import React from 'react';
import { DynamicColorTag } from '@app/ui';

export const ProviderSpecialtyTag: React.FC<{ name?: string | null }> = ({ name }) => (
  <DynamicColorTag label={name} />
);
